import zombieRg from "../assets/zombie-rg.png";
import "./About.scss";

const About = () => {
  return (
    <div className="section">
      <div className="container">
        <div className="columns is-vcentered">
          <div className="column is-5 zombie-rg">
            <figure className="image">
              <img src={zombieRg} alt="reply guy" />
            </figure>
          </div>
          <div className="column">
            <div className="content">
              <div id="title">
                We are
                <br />
                <span className="title-colored">Reply Guys</span>
              </div>
              <p id="bodyText">
                Reply Guys is a collection of 6969 randomly generated pfps —
                hosted on the blockchain but living on social media.
                <br />
                Reply guys are a positive force on social media, spreading good
                vibes and having a real impact on the online community.
                <br />
                But there's more to it than just spreading good vibes. Each
                reply guy is eligible for a variety of rewards.
                <br />
                We aim to finally recognize and reward the hard work and
                positive impact that reply guys have on social media.
              </p>
            </div>
          </div>
        </div>
      </div>
      <hr className="zombie-ender" />
    </div>
  );
};

export default About;
